import { useTranslation } from "react-i18next";

import { styled } from "styled-components";

import { Message } from "simplydo/react/ui";

const StyledMessageItem = styled(Message.Item)<{ $password?: string }>`
  ${({ $password }) =>
    $password && $password.length < 8 ?
      `
    color: #cc202d;
  `
    : ""}
`;

const PasswordGuidance = ({ password = "" }) => {
  const { t } = useTranslation();
  return (
    <Message>
      <Message.Header>
        {t("entry.register.passwordGuidance.title")}
      </Message.Header>
      <Message.List>
        <StyledMessageItem $password={password}>
          {t("entry.register.passwordGuidance.passwordLimit")}
        </StyledMessageItem>
        <StyledMessageItem>
          {t("entry.register.passwordGuidance.noRepeat")}
        </StyledMessageItem>
        <StyledMessageItem>
          {t("entry.register.passwordGuidance.manager")}
        </StyledMessageItem>
      </Message.List>
    </Message>
  );
};

export default PasswordGuidance;
